import React, { useEffect, useCallback, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import useAuthStore from "../store/authStore";
import useThemeStore from "../store/themeStore";

import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import api from "../utils/api";
import SnowfallEffect from "../components/SnowfallEffect";
import { Gift } from "lucide-react";

const JoinGroup = () => {
  const { inviteCode } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const { t } = useTranslation();
  const emailSchema = z
    .string()
    .email("Bitte gib eine gültige E-Mail-Adresse ein");
  const [loading, setLoading] = useState(false);
  const { theme } = useThemeStore();

  const joinGroup = useCallback(async () => {
    if (!inviteCode) {
      toast.error("Error", { description: "Invalid invite link" });
      navigate("/");
      return;
    }

    try {
      // hier kein Body nötig, wir schicken den Code im Pfad
      const res = await api.post(`/groups/join/${inviteCode}`);
      toast.success("Success", { description: "Joined group successfully!" });
      navigate(`/group/${res.data.group.id}`);
    } catch (error) {
      toast.error("Error", {
        description: error?.response?.data?.detail || "Failed to join group",
      });
      navigate("/");
    }
  }, [inviteCode, navigate]);

  useEffect(() => {
    if (isAuthenticated) {
      joinGroup();
    }
  }, [isAuthenticated, joinGroup]);

  const handleSendMagicLinkGroupInvite = async () => {
    if (!email) {
      toast.error(t("error"), { description: "Email is required" });
      return;
    }

    const parsed = emailSchema.safeParse(email);
    if (!parsed.success) {
      toast.error(t("error"), { description: parsed.error.issues[0]?.message });
      return;
    }

    // setLoading(true);
    await api.post("/auth/request-magic-link-group-invite", {
      email,
      name: name || email.split("@")[0],
      language: "en",
      inviteCode: inviteCode,
    });
    toast.success(t("success"), { description: t("checkEmail") });
    // setShowAuthDialog(false);
    try {
    } catch (error) {
      console.error("error:", error);
      toast.error(t("error"), {
        description:
          error.response?.data?.detail || "Failed to send magic link",
      });
    }
    // setLoading(false);
  };

  return (
    <div
      className={`min-h-screen ${
        theme === "dark"
          ? "bg-gray-900"
          : "bg-gradient-to-br from-red-50 via-pink-50 to-blue-50"
      } py-8 px-4`}
    >
      <SnowfallEffect />
      <div className="mt-16 flex flex-col gap-3 items-center justify-center container mx-auto max-w-xl">
        <div className="flex flex-row gap-3 items-center mb-2">
          <Gift className="h-10 w-10 text-rose-600" />
          <h1 className="text-4xl font-bold text-rose-600 dark:text-white">
            Jingolin
          </h1>
        </div>
        <div className="flex flex-row">
          <div className="text-lg">Dein Invite Code: {inviteCode}</div>
        </div>
        <Input
          data-testid="email-input"
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
        />
        <Input
          data-testid="name-input"
          id="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Your Name"
        />
        <Button
          data-testid="join-group-button"
          onClick={handleSendMagicLinkGroupInvite}
          className="w-full"
        >
          {t("joinGroup")}
        </Button>
      </div>
    </div>
  );
};

export default JoinGroup;
